import { useState } from "react";
import { fetchVouchersReportCsv } from "../api/fetchVouchersReport/fetchVouchersReportCsvApi";
import { FetchVouchersReportParams } from "../api/fetchVouchersReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadVouchersReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchVouchersReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchVouchersReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `vouchers-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
